import { Component } from '@angular/core';
import {CardComponent} from '../../../../shared/components/card/card.component';

@Component({
  selector: 'app-page-privacy',
  imports: [
    CardComponent
  ],
  templateUrl: './page-privacy.component.html',
  styleUrl: './page-privacy.component.scss'
})
export class PagePrivacyComponent {

}
